export const getGreeting = () => {
  const currentDate = new Date();
  const currentHour = currentDate.getHours();

  if (currentHour >= 12 && currentHour <= 17) {
    return 'Good afternoon';
  }

  if (currentHour >= 17 || currentHour <= 5) {
    return 'Good evening';
  }

  return 'Good morning';
};
